.errorNav {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding-top: 8px;
}

.footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 16px 0;
  background-color: transparent;
}

.count {
  color: var(--text-primary);
  font-weight: 500;
}

.countEmpty {
  color: var(--danger);
}

.buttonGroup {
  border-left: 1px solid var(--gray-600);
}
